import script from "./ChatStarters.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatStarters.vue?vue&type=script&setup=true&lang=js"

import "./ChatStarters.vue?vue&type=style&index=0&id=6f7aa34e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f7aa34e"]])

export default __exports__